import { ScreenSize } from '../types';

export function GetScreenSize() {
  let screenWidth = window.innerWidth;
  if (screenWidth >= ScreenSize.Xxl) {
    return ScreenSize.Xxl;
  } else if (screenWidth >= ScreenSize.Xl) {
    return ScreenSize.Xl;
  } else if (screenWidth >= ScreenSize.Lg) {
    return ScreenSize.Lg;
  } else if (screenWidth >= ScreenSize.Md) {
    return ScreenSize.Md;
  } else if (screenWidth >= ScreenSize.Sm) {
    return ScreenSize.Sm;
  } else {
    return ScreenSize.Xs;
  }
}
